import { useQuery } from '@tanstack/react-query';
import type { Nation, RuleSetResponse } from '@seventide/types';
import { api } from '../lib/api';

export interface LoadedRuleSet extends RuleSetResponse {
  /** Parsed rule constants (`payload.values`), used to fill `{{values.*}}` placeholders in content. */
  values: Record<string, unknown>;
}

/** GET /api/rules/current?nation= — the active signed rule set (RE-1, R-5.6). */
export function useRuleSet(nation: Nation | undefined, enabled = true) {
  return useQuery({
    queryKey: ['rules', 'current', nation ?? 'england'],
    queryFn: async (): Promise<LoadedRuleSet> => {
      const rs = await api.get<RuleSetResponse>('/api/rules/current', {
        query: { nation: nation ?? 'england' },
        redirectOn401: false,
      });
      return { ...rs, values: parseRuleValues(rs.payload) };
    },
    enabled,
    staleTime: 60 * 60_000,
  });
}

function parseRuleValues(payload: string): Record<string, unknown> {
  try {
    const parsed = JSON.parse(payload) as { values?: Record<string, unknown> } & Record<string, unknown>;
    return parsed.values ?? parsed;
  } catch {
    return {};
  }
}
